import styled from "styled-components";

export const StyledTabPanel = styled.div`
  overflow-y: scroll;
`;
